import React from 'react';

const SelectContent = ({ children, onItemClick }) => {
  return (
    <div className="py-1 max-h-60 overflow-y-auto bg-white border-gray-200 rounded-md shadow-lg">
      {React.Children.map(children, (child) => {
        if (child.type.displayName === 'SelectItem') {
          return React.cloneElement(child, { 
            onClick: () => onItemClick(child.props.value),
            className: `px-3 py-2 text-sm cursor-pointer hover:bg-gray-100 ${child.props.disabled ? 'opacity-50 cursor-not-allowed' : ''}`
          });
        }
        return child;
      })}
    </div>
  );
};

SelectContent.displayName = 'SelectContent';
export default SelectContent;